import styled from 'styled-components';
import { StyleColor, BaseStyledComponentProps } from '../../../utils/styles-constants';
import { hexToRgba } from '../../../utils/style';

interface StyledSwitchProps extends BaseStyledComponentProps {
	isActive: boolean;
	activeColor?: string;
}

const Wrapper = styled('div')`
	display: flex;
	align-items: center;
`;

const StyledSwitch = styled('label')`
	box-sizing: border-box;
	position: relative;
	flex: 0 0 auto;
	width: 51px;
	height: 32px;
	border: 2px solid ${({ isActive, activeColor, theme }: StyledSwitchProps) => isActive
		? activeColor || theme.primary.actionColor
		: hexToRgba(StyleColor.Black, 10)
	};
	border-radius: 20px;
	background-color: ${({ isActive, activeColor, theme }: StyledSwitchProps) => isActive
		? activeColor || theme.primary.actionColor
		: StyleColor.White
	};
	transition: all 0.2s ease;
	cursor: pointer;

	&::before {
		content: '';
		box-sizing: border-box;
		position: absolute;
		width: 30px;
		height: 30px;
		border: 1px solid ${({ isActive, activeColor, theme }: StyledSwitchProps) => isActive
			? activeColor || theme.primary.actionColor
			: hexToRgba(StyleColor.Black, 10)
		};
		border-radius: 50%;
		background-color: ${StyleColor.White};
		box-shadow: 0 3px 3px 0 ${hexToRgba(StyleColor.Black, 5)},
					0 2px 2px 0 ${hexToRgba(StyleColor.Black, 10)},
					0 3px 1px 0 ${hexToRgba(StyleColor.Black, 5)};
		transform: translate(${({ isActive }: StyledSwitchProps) => isActive ? '60%, -1px' : '-1px, -1px'});
		transition: transform 0.2s ease;
	}

	input {
		display: none;
	}
`;

export {
	Wrapper,
	StyledSwitch,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Form/Switch/styles.ts